/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Transition as TransitionItem } from 'react-transition-group';
import { func } from '../../../util';

/**
 *
 * @param {object} config
 * @param {function} config.enter - fired before the "entering"
 * @param {function} config.exit - fired before the "exiting"
 * @param {number} [config.timeout=200]
 * @param {boolean} extraWrap
 */
export function Transition(config, extraWrap = false) {
  return ComposedComponent => {
    function Wrapped(props) {
      const onEnter = node => {
        if (config.enter) {
          config.enter(node, func.noop);
        }
      };

      const onExit = node => {
        if (config.exit) {
          config.exit(node, func.noop);
        }
      };

      const timeout = config.timeout === undefined ? 200 : config.timeout;
      const child = extraWrap ? (
        <div>
          <ComposedComponent {...props} />
        </div>
      ) : (
        <ComposedComponent {...props} />
      );

      return (
        <TransitionItem
          timeout={timeout}
          in={props.in}
          mountOnEnter
          unmountOnExit
          onEnter={onEnter}
          onExit={onExit}
        >
          {child}
        </TransitionItem>
      );
    }

    Wrapped.displayName = `Transition.${ComposedComponent.displayName || 'anonymous'}`;
    return Wrapped;
  };
}
